export default {
  wallet: {
    title: 'Dompet',
    balance: 'Baki',
    deposit: 'Deposit',
    withdraw: 'Keluarkan',
    rollover: 'Rollover',
    transaction: 'Transaksi',
    myBet: 'Pertaruhan Saya',
    totalBalance: 'Jumlah Baki',
    withdrawableBalance: 'Baki Boleh Dikeluarkan',
    bonus: 'Bonus',
    bonusBalance: 'Baki Bonus',
    cashBalance: 'Baki Tunai',
    withdrawable: 'Boleh Dikeluarkan',
    depositNow: 'Deposit Sekarang',
    getBonus: 'Dapatkan Bonus',
    bonusGames: 'Permainan Bonus',
    playNow: 'Main Sekarang',
    fiatAccount: 'Akaun Fiat',
    cash: 'Tunai',
    rules: 'Peraturan',
    ruleQ1: '1. Apakah itu Bonus?',
    ruleA1: 'Bonus ialah ganjaran yang diberikan oleh platform selepas menyertai aktiviti dan boleh digunakan untuk bertaruh dalam permainan bonus yang ditetapkan.',
    ruleQ2: '2. Bagaimana saya boleh menggunakan bonus?',
    ruleA2: 'Bonus hanya boleh digunakan untuk pertaruhan selepas baki dompet tunai habis. Bonus mesti memenuhi syarat pertaruhan sebelum boleh ditukar kepada dompet tunai.',
    ruleQ3: '3. Permainan apa yang menyokong pertaruhan bonus?',
    ruleA3: 'Kebanyakan permainan slot menyokong pertaruhan bonus. Untuk senarai permainan terperinci, sila rujuk halaman Permainan Bonus.',
    ruleQ4: '4. Adakah sebarang sekatan untuk menukar bonus kepada dompet tunai?',
    ruleA4: 'Setelah syarat pertaruhan bonus dipenuhi, anda boleh menukar bonus asal kepada dompet tunai di Pusat Ganjaran. Sebarang baki keuntungan bonus akan dikembalikan ke Dompet Bonus, dan syarat pertaruhan akan dikira semula.',
    ruleQ5: '5. Adakah sebarang sekatan untuk menukar keuntungan bonus kepada dompet tunai?',
    ruleA5: 'Keuntungan bonus mesti memenuhi syarat pertaruhan 15x. Keuntungan bonus maksimum yang boleh ditukar kepada dompet tunai ialah USDT5,000.00, dan jumlah maksimum setiap pertaruhan ialah USDT1,000.00.',
    ruleQ6: '6. Bagaimana syarat pertaruhan dikira?',
    ruleA6: 'Permainan slot: Jumlah pertaruhan = Syarat pertaruhan. Permainan lain: Jumlah pertaruhan = Nilai mutlak keuntungan (sehingga jumlah pertaruhan)',
    select: 'Pilih',
    currency: 'Mata Wang',
    loading: 'Memuatkan...',
    noMoreData: 'Tiada data lagi',
    noData: 'Tiada data',
    colType: 'Jenis',
    colTime: 'Masa',
    colStatus: 'Status',
    colAmount: 'Jumlah',
    colBalance: 'Baki',
    allType: 'Semua Jenis',
    allStats: 'Semua Status',
    colWallet: 'Dompet',
    colCurrent: 'Semasa',
    colRequired: 'Diperlukan',
    colStats: 'Status',
    totalVaultBalance: 'Jumlah Baki Peti Simpanan',
    amount: 'Jumlah',
    availableBalance: 'Baki Tersedia:',
    max: 'MAKS',
    depositInVault: 'Deposit ke Peti Simpanan',
    depositCurrency: 'Mata Wang Deposit',
    currencyBalance: 'Baki Mata Wang',
    history: 'Sejarah',
    vaultRules: 'Peraturan Peti Simpanan',
    vaultRule1: 'Peti Simpanan ialah tempat selamat untuk menyimpan dana tanpa perlu risau tentang yuran transaksi atau kelewatan blockchain. Peti Simpanan berfungsi seperti dompet digital anda sendiri atau seperti akaun simpanan bank. Ia amat selamat – berkat 2FA – dan anda boleh melaksanakan langkah keselamatan tambahan untuk menjaga dana di dalamnya.',
    vaultRule2: 'Deposit dan pengeluaran dana dalam Peti Simpanan dilindungi oleh 2FA dan boleh diakses oleh pendeposit pada bila-bila masa.',
    vaultRule3: 'Dana dalam Peti Simpanan tidak akan disentuh oleh sesiapa kecuali pendeposit. Ia milik anda dan akan sentiasa selamat untuk anda gunakan!',
    selectTime: 'Pilih Masa',
    colGame: 'Permainan',
    colBet: 'Pertaruhan',
    colWin: 'Menang',
    colProfit: 'Keuntungan',
    sports: 'Sukan',
    allGames: 'Semua permainan',
    today: 'Hari Ini',
    yesterday: 'Semalam',
    last3Days: '3 hari lepas',
    last7Days: '7 hari lepas',
    last15Days: '15 hari lepas',
    last30Days: '30 hari lepas',
  },
};
